import { crudRequest } from '@/services/api';

const state = {}
for (let dsIndex = 0; dsIndex < 2; dsIndex++) {
  state[`unloaded${dsIndex}`] = {}
}

export default {
  namespace: 'unloaded',
  state: { ...state },


  effects: {
    *unloaded({ payload: { data, dsIndex } }, { call, put, select }) {
      yield put({ type: 'updateState', payload: { [`unloaded${dsIndex}`]: data[0].result } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}